import apiPaths from '../../api-paths';

export default {
    index(query = '') {
        return axios.get(`${apiPaths.CRM}/mail-groups${query}`);
    },
    get(id) {
        return axios.get(`${apiPaths.CRM}/mail-groups/${id}`);
    },
    save(data) {
        return axios.put(`${apiPaths.CRM}/mail-groups`, data);
    },
    delete(id) {
        return axios.delete(`${apiPaths.CRM}/mail-groups/${id}`);
    }
}